export default {
	tenantId: "msig_uat",
	appId: "covergo_crm",

	fileSystem: {
		bucketName: "msig--uat"
	}
}
